(() => {
  const ADDED_EVENTS = ['st-added-product', 'swishlist:st-added-product'];
  const DELETED_EVENTS = ['st-deleted-product', 'swishlist:st-deleted-product'];

  const whenSWishlistReady = (callback) => {
    if (window.SWishlist) {
      callback();
      return;
    }
    let settled = false;
    const run = () => {
      if (settled) return;
      settled = true;
      callback();
    };
    document.addEventListener('SWishlistReady', run, { once: true });
    let attempts = 0;
    const timer = setInterval(() => {
      if (window.SWishlist) {
        clearInterval(timer);
        run();
      } else if ((attempts += 1) > 40) {
        clearInterval(timer);
      }
    }, 250);
  };

  class CartWishlist extends HTMLElement {
    connectedCallback() {
      this.handle = this.dataset.handle || '';
      this.button = this.querySelector('.cart-item__wishlist-btn');
      this.labelEl = this.querySelector('[data-cart-wishlist-label]') || this.button;
      this.labelAdd = this.dataset.labelAdd || '';
      this.labelRemove = this.dataset.labelRemove || '';
      this.handleClick = this.handleClick.bind(this);
      this.handleExternalChange = this.handleExternalChange.bind(this);

      if (this.button) this.button.addEventListener('click', this.handleClick);
      [...ADDED_EVENTS, ...DELETED_EVENTS].forEach((name) =>
        window.addEventListener(name, this.handleExternalChange)
      );

      whenSWishlistReady(() => this.syncState());
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.handleClick);
      [...ADDED_EVENTS, ...DELETED_EVENTS].forEach((name) =>
        window.removeEventListener(name, this.handleExternalChange)
      );
    }

    async syncState() {
      if (!window.SWishlist || !this.handle || typeof window.SWishlist.getList !== 'function') return;
      try {
        const list = await window.SWishlist.getList();
        const inList =
          Array.isArray(list) &&
          list.some(
            (product) => product && (product.handle === this.handle || product.productHandle === this.handle)
          );
        this.setAdded(inList);
      } catch (error) {
      }
    }

    setAdded(isAdded) {
      this.isAdded = isAdded;
      this.classList.toggle('is-active', isAdded);
      if (this.button) this.button.setAttribute('aria-pressed', String(isAdded));
      if (this.labelEl) {
        const label = isAdded ? this.labelRemove : this.labelAdd;
        if (label) this.labelEl.textContent = label;
      }
    }

    handleExternalChange() {
      whenSWishlistReady(() => this.syncState());
    }

    async handleClick(event) {
      event.preventDefault();
      if (!window.SWishlist || !this.handle) return;

      const nextAdded = !this.isAdded;
      this.setAdded(nextAdded);

      try {
        if (nextAdded) {
          await window.SWishlist.addToWishlist(this.handle);
        } else {
          await window.SWishlist.removeFromWishlist(this.handle);
        }
      } catch (error) {
        this.setAdded(!nextAdded);
      }
    }
  }

  if (!customElements.get('cart-wishlist')) {
    customElements.define('cart-wishlist', CartWishlist);
  }
})();
